import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Styles from './assets/css/styles.css'
import { VueMaskDirective } from 'v-mask'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
Vue.config.productionTip = false
Vue.directive('mask', VueMaskDirective);
new Vue({
  router,
  store,
  Styles,
  render: h => h(App)
}).$mount('#app')
